import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static HOLD = 2000

  connect () {
    this.handler = () => this.flash()
    document.addEventListener('save:done', this.handler)
  }

  disconnect () {
    clearTimeout(this.timer)
    document.removeEventListener('save:done', this.handler)
  }

  // Private

  flash () {
    clearTimeout(this.timer)
    this.element.classList.remove('opacity-0', 'translate-y-2')
    this.timer = setTimeout(() => this.element.classList.add('opacity-0', 'translate-y-2'), this.constructor.HOLD)
  }
}
